<template>
  <q-form ref="editForm">
    <c-card title="기본정보" :noMarginPadding="true" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-label-text title="과목명" :value="educationInfo.educationName"></c-label-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-label-text title="교육과정" :value="educationInfo.educationCourseName"></c-label-text>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <c-label-text title="교육종류1" :value="educationInfo.educationKindCdLargeName"></c-label-text>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <c-label-text title="교육종류2" :value="educationInfo.educationKindCdSmallName"></c-label-text>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <c-label-text title="사업장" :value="educationInfo.plantName"></c-label-text>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <c-label-text title="주관부서" :value="educationInfo.departmentDeptName"></c-label-text>
        </div>
      </template>
    </c-card>
    <c-card title="서명 및 의견" class="cardClassDetailInfo">
      <template slot="card-button">
        <q-btn-group outline >
           <!-- v-if="educationInfo.checkCompleteFlag !== 'Y'" -->
          <c-btn v-if="educationInfo.documentStatusCd !== 'ESC000010'" label="서명지우기" color="red-3" :showLoading="false" @btnClicked="eraseSignature" />
          <c-btn v-if="educationInfo.documentStatusCd !== 'ESC000010'" label="저장" color="blue" :showLoading="false" @btnClicked="saveAsSvg" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12">
          <div class="container">
            <div class="row items-center all-pointer-events">
              <b>
                <font id="signatureTitle">&nbsp;&nbsp;서명란</font>
                <font id="signatureContent">&nbsp;&nbsp; [ 이름을 정자로 입력하세요. ]</font>
              </b>
            </div>
            <VueSignaturePad id="signature"  height="200px" ref="signaturePad" :options="options"/>
          </div>
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-textarea
            :disabled="educationInfo.documentStatusCd === 'ESC000010'"
            :rows="4"
            label="의견"
            name="opinionContent"
            v-model="educationInfo.opinionContent">
          </c-textarea>
        </div> -->
      </template>
    </c-card>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import VueSignaturePad from 'vue-signature-pad';
import Vue from 'vue';
import mobileConfig from '@/js/mobileConfig';
let signaturePad = null;
Vue.use(VueSignaturePad)
export default {
  name: 'education-complete',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        eduEducationId: '',
      }),
    },
  },
  data() {
    return {
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      options: {
        penColor: "#000000",
      },
      educationInfo: {
        eduEducationId: '',
        educationName: '',
        eduCourseId: '',
        plantCd: '',
        educationCourseName: '',
        educationKindCdLarge: null,
        educationKindCdSmall: null,
        educationTypeCd: null,
        departmentDeptCd: '',
        departmentDeptName: '',
        executionBudget: '',
        estimatedEducationExpenses: '',
        educationMethodName: '',
        educationMethodCd: null,
        educationOverview: '',
        evaluationEvalCd: '',
        documentStatusCd: '',
        qrCodeRoute: '',

        opinionContent: '',
        electronSignature: '',
        attendeesId: '',
        attendeesNo: '',
        attendanceTime: '',
        checkCompleteFlag: '',

        regUserId: '',
        chgUserId: '',
        eduSubjectList: [], // 과정별 교육과목
        eduAttendeeList: [],
      },
      editable: true,
      saveType: 'POST',
      isSave1: false,
      isSave2: false,
      updateUrl: '',
      insertUrl: '',
      deleteUrl: '',
      searchUrl: '',
      items: [],
      getUrl: '',
      updateSignatureUrl: '',
      rowIndex: 0,
      windowWidth: '',
    };
  },
  computed: {
    disabled() {
      return (Boolean(this.educationInfo.documentStatusCd) && this.educationInfo.documentStatusCd === 'ESC000010')
    },
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
    window.addEventListener('resize', this.setSize);
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setSize);
  },
  methods: {
    init() {
      // role setting
      this.getUrl = mobileConfig.sop.edu.result.get.mobile.url;
      // url setting
      // code setting

      this.updateSignatureUrl = mobileConfig.sop.edu.plan.update.targetUser.signature.url;
      if (!this.$refs.signaturePad) {
        return;
      }
      signaturePad = this.$refs.signaturePad
      // signaturePad.lockSignaturePad();
     
      this.getDetail();
      // list setting
    },
    getDetail() {
      if (this.popupParam.eduEducationId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.eduEducationId, this.$store.getters.user.userId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.educationInfo = _result.data

          
          if (this.educationInfo.electronSignature) {
            signaturePad.fromDataURL(this.educationInfo.electronSignature);
          }
          if (this.educationInfo.documentStatusCd === 'ESC000010') {
            signaturePad.lockSignaturePad();
          }
        })
      }
    },
    setSize() {
      signaturePad.fromDataURL(this.educationInfo.electronSignature);
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      this.getDetail();
    },
    callback1(data, rowIndex) {
      let refName = 'proxy1_' + rowIndex;
      this.$refs[refName].hide();
    },
    saveAsSvg() {
      var data = ''
      if (signaturePad.saveSignature().isEmpty) {
        data = ''
      } else {
        data = signaturePad.saveSignature().data;
      }
      this.educationInfo.electronSignature = data;
      
      if (!this.educationInfo.electronSignature) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '서명하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.updateSignatureUrl;
          this.$http.type = 'PUT';
          this.$http.param = {
            electronSignature: this.educationInfo.electronSignature,
            attendeesId: this.educationInfo.attendeesId,
            eduEducationId: this.educationInfo.eduEducationId,
            opinionContent: this.educationInfo.opinionContent,
            regUserId: this.$store.getters.user.userId,
            chgUserId: this.$store.getters.user.userId,
            checkCompleteFlag: 'N'
          };
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.getDetail();
            // this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
    eraseSignature() {
      signaturePad.clearSignature();
      this.educationInfo.electronSignature = '';
    },
    reset() {
      Object.assign(this.$data.info, this.$options.data().info);
    },
  }
};
</script>
<style>
#signature {
  border: double 1px transparent;
  border-radius: 2;
  background-image: linear-gradient(white, white),
      /* radial-gradient(circle at top left, #4bc5e8, #9f6274); */
   radial-gradient(circle at top left, #000000, #000000);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  /* margin-top: 5px !important; */
  margin-bottom: 20px !important;
  padding: 0px 8px 0px 2px
}
#signatureTitle {
  color: #3199c5 !important;
  font-size: 0.9em !important;
  font-weight: 600;
}
#signatureContent {
  color: #df2626 !important;
  font-size: 0.8em !important;
  font-weight: 600;
}
</style>